// extracted by mini-css-extract-plugin
module.exports = {"popup_panel":"FJVoice_popup_panel__1qjZl","mute":"FJVoice_mute__xWfDl","mute_label":"FJVoice_mute_label__2Rdu1"};